import React from 'react';

import LocalisedMessage from 'components/Common/LocalisedMessage';

const NoFormRequiredResult = () => (<div id="formResult" className="question-card-wrapper matched-form">
  <p className="question-title"><strong><LocalisedMessage id="noFormRequired.title" /></strong></p>
  <p><LocalisedMessage id="noFormRequired.text" /></p>
</div>);

export default NoFormRequiredResult;
